import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/build/css/mdb.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueScrollTo from 'vue-scrollto'
import VueObserveVisibility from 'vue-observe-visibility'
import FlagIcon from 'vue-flag-icon'
import App from './App.vue'
import router from './router'

Vue.use(VueRouter)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(VueAxios, axios)
Vue.use(VueScrollTo, {
  offset: -50
})
Vue.use(VueObserveVisibility)
Vue.use(FlagIcon)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
